import { IButtonProps } from "../../interfaces/types";
import IconSave from "../icons/IconSave";

export default function ButtonSave(props: IButtonProps) {
  const { ...rest } = props;
  return (
    <button
      {...rest}
      type="button"
      className="btn btn-sm btn-outline-primary-subtle col d-flex flex-column align-items-center gap-1 py-2"
      title="Gem ændringer"
    >
      <IconSave />
      <small>Gem ændringer</small>
    </button>
  );
}
